export default __webpack_public_path__ + "static/media/Harry's Wand - Img - Wip 2_01.1530a54f.jpg";